import { gql } from 'graphql-request';

export default gql`
  query CdrInteractions(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    cdrInteractions(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      cdrInteractions {
        id
        account_id
        legs {
          id
          doc
        }
        doc
        createdAt
        updatedAt
      }
    }
  }
`;
